import { SHOP_THIS_STORE_ACTIONS } from './ShopThisStore.constants';

export const getCategoryBasedProducts = (payload) => {
  return {
    payload,
    type: SHOP_THIS_STORE_ACTIONS.FETCH_HLP_CATEGORY,
  };
};

export const setShopThisStorePlpProducts = (payload) => {
  return {
    payload,
    type: SHOP_THIS_STORE_ACTIONS.SET_SHOP_THIS_STORE_PLP_PRODUCTS,
  };
};

export const setHorizontalProducts = (payload) => {
  return {
    payload,
    type: SHOP_THIS_STORE_ACTIONS.SET_HPLP_PRODUCTS,
  };
};

export const getMoreHorizontalCategoryShopThisStore = (payload) => {
  return {
    payload,
    type: SHOP_THIS_STORE_ACTIONS.FETCH_MORE_HORIZONTAL_CATEGORY_PRODUCTS_STS,
  };
};

export const getL1Categories = (payload) => {
  return {
    payload,
    type: SHOP_THIS_STORE_ACTIONS.FETCH_L1_CATEGORIES,
  };
};

export const getL2Categories = (storeId, categoryFilter, currentL2Category) => {
  return {
    payload: { storeId, categoryFilter, currentL2Category },
    type: SHOP_THIS_STORE_ACTIONS.FETCH_L2_CATEGORIES,
  };
};

export const setL1CategorySelection = (categoryItem) => {
  return {
    payload: { categoryItem },
    type: SHOP_THIS_STORE_ACTIONS.SET_L1_CATEGORY_SELECTION,
  };
};

export const setL1CategorySelectionLoaded = (payload) => {
  return {
    payload,
    type: SHOP_THIS_STORE_ACTIONS.SET_L1_CATEGORY_SELECTION_LOADED,
  };
};

export const setL2CategorySelection = (categoryItem) => {
  return {
    payload: { categoryItem },
    type: SHOP_THIS_STORE_ACTIONS.SET_L2_CATEGORY_GROUPING_SELECTION,
  };
};

export const setL2CategorySelectionLoaded = (payload) => {
  return {
    payload,
    type: SHOP_THIS_STORE_ACTIONS.SET_L2_CATEGORY_GROUPING_SELECTION_LOADED,
  };
};

export const setGetL1CategoriesLoading = (payload) => {
  return {
    payload,
    type: SHOP_THIS_STORE_ACTIONS.SET_L1_CATEGORIES_LOADING,
  };
};

export const setGetL2CategoriesLoading = (payload) => {
  return {
    payload,
    type: SHOP_THIS_STORE_ACTIONS.SET_L2_CATEGORIES_LOADING,
  };
};

export const setSelectedL1CategoryContent = (selectedCategory) => {
  return {
    payload: { selectedCategory },
    type: SHOP_THIS_STORE_ACTIONS.SET_SELECTED_L1_CATEGORY_CONTENT,
  };
};

export const setSelectedL2CategoryGroupID = (selectedGroupId) => {
  return {
    payload: { selectedGroupId },
    type: SHOP_THIS_STORE_ACTIONS.SET_SELECTED_L2_CATEGORY_GROUP_ID,
  };
};
export const setLoadedInShopThisStore = (payload) => {
  return {
    payload,
    type: SHOP_THIS_STORE_ACTIONS.LOADED_IN_SHOP_THIS_STORE,
  };
};
export const getFilteredL2AndL1Categories = (storeId, breadCrumbs) => {
  return {
    payload: { storeId, breadCrumbs },
    type: SHOP_THIS_STORE_ACTIONS.FETCH_FILTERED_L2_AND_L1_CATEGORIES,
  };
};

export const setIsShopThisStoreHplpLoading = (payload) => {
  return {
    payload,
    type: SHOP_THIS_STORE_ACTIONS.SHOP_THIS_STORE_HPLP_LOADED,
  };
};

export const setIsDefaultCategoryLoaded = (payload) => ({
  type: SHOP_THIS_STORE_ACTIONS.SET_IS_DEFAULT_CATEGORIES_LOADED,
  payload,
});

export const setSelectedStoreL1Category = (payload) => ({
  type: SHOP_THIS_STORE_ACTIONS.SET_SELECTED_STORE_L1_CATEGORIES,
  payload,
});

export const setSelectedStoreL2Category = (payload) => ({
  type: SHOP_THIS_STORE_ACTIONS.SET_SELECTED_STORE_L2_CATEGORIES,
  payload,
});

export const changeL2Categories = (payload) => ({
  type: SHOP_THIS_STORE_ACTIONS.CHANGE_L2_CATEGORIES,
  payload,
});

export default {
  getCategoryBasedProducts,
};
